import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $;
@Component({
  selector: 'app-editaddress',
  templateUrl: './editaddress.page.html',
  styleUrls: ['./editaddress.page.scss'],
})
export class EditaddressPage implements OnInit {
  subs:any;
  loggeduser: any;
  id_subscriptions: any;
  first_name: any;
  last_name: any;
  address_1: any;
  address_2: any;
  city: any;
  state: any;
  zip: any;
  phone: any;
  id_user: any;
  total: any;
  disc: any;
  shipping: any;
  subtotal: any;
  mealspermonth: any;
  amofmelas:any; 
  plan_name:any;
  constructor(public router: Router) { }

  ngOnInit() {
  }

  ionViewWillEnter(){
    $.getJSON(localStorage.apiurl,{
      op:"get_one_det",
      id_user: localStorage.loggeduser,
      sub:localStorage.selectedplan
    },(r)=>{
      this.subs = r;
      console.log(this.subs);
        this.first_name = r[0].first_name;
        this.last_name = r[0].last_name;
        this.address_1 = r[0].address_1;
        this.address_2 = r[0].address_2;
        this.city = r[0].city;
        this.state = r[0].state;
        this.zip = r[0].zip;
        this.phone = r[0].phone;
   })
  }
  


  updateinfo(){
    if(this.first_name == ""){
      alert("Fill up the form correctly check for blank spaces.");
      return;
    } 

    if(this.last_name == ""){
      alert("Fill up the form correctly check for blank spaces.");
      return;
    }

    if(this.address_1 == ""){
      alert("Fill up the form correctly check for blank spaces.");
      return;
    } 

    if (this.address_2 == ""){
      alert("Fill up the form correctly check for blank spaces.");
      return;
    }

    if(this.city == ""){
      alert("Fill up the form correctly check for blank spaces.");
      return;
    }

    if(this.state == ""){
      alert("Fill up the form correctly check for blank spaces.");
      return;
    }

    if(this.zip == ""){
      alert("Fill up the form correctly check for blank spaces.");
      return;
    }

    if(this.phone == ""){
      alert("Fill up the form correctly check for blank spaces.");
      return;
    }

    $.get(localStorage.apiurl, { 
      op: "update_subs",
      id_user:this.loggeduser,
      first_name:this.first_name,
      last_name:this.last_name,
      address_1:this.address_1,
      address_2:this.address_2,
      city:this.city,
      state:this.state,
      zip:this.zip,
      phone:this.phone,
      subs:localStorage.selectedplan
    },(r)=>{
      console.log(r);      
      this.router.navigate(['/account']) //aqui yo se que va a otra ruta
    })
  }

  back(){
    this.router.navigate(['/account'])
  }
 
}
